import { render, staticRenderFns } from "./ZiXun.vue?vue&type=template&id=6a55a344&scoped=true"
import script from "./ZiXun.vue?vue&type=script&lang=js"
export * from "./ZiXun.vue?vue&type=script&lang=js"
import style0 from "./ZiXun.vue?vue&type=style&index=0&id=6a55a344&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a55a344",
  null
  
)

export default component.exports